import { ReactNode } from 'react';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {
  Box,
  IconButton,
  Paper,
  Skeleton,
  Tooltip,
  Typography,
} from '@mui/material';
import { sharedColors } from '../../utils/Style';

interface DashboardStatsCardProps {
  title: string;
  icon: ReactNode;
  tooltip?: string;
  value: string;
}

export const DashboardStatsCard = (props: DashboardStatsCardProps) => {
  return (
    <Paper
      elevation={3}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        py: 3,
        px: 2,
        gap: 3,
        backgroundColor: sharedColors.gray1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        <Typography variant='h6'>{props.title}</Typography>

        {!!props.tooltip && (
          <Tooltip
            title={props.tooltip}
            enterTouchDelay={0}
            leaveTouchDelay={5000}
          >
            <IconButton size='small' color='primary'>
              <HelpOutlineIcon fontSize='small' />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          alignItems: 'center',
        }}
      >
        {props.icon}

        <Box sx={{ flexGrow: 1 }} />

        <Typography variant='h5'>{props.value}</Typography>
      </Box>
    </Paper>
  );
};

export const DashboardStatsCardEmpty = () => (
  <Skeleton variant='rectangular' height={150} width='100%' />
);
